import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from 'tss-react/mui';
import PlayCircleFilledIcon from "@mui/icons-material/PlayCircleFilled";
import YouTubeResponsiveEmbed from "../YouTubeResponsiveEmbed/YouTubeResponsiveEmbed";

const useStyles = makeStyles()((theme, _params, classes) => ({
  facadeContainer: {
    position: "relative",
    width: "100%",
    paddingTop: "56.25%", // 16:9 aspect ratio
    cursor: "pointer",
    backgroundColor: "transparent",
    overflow: "hidden", // Hide cropped parts
    [`&:hover .${classes.playIcon}`]: {
      transform: "translate(-50%, -50%) scale(1.1)",
    },
  },
  thumbnail: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover", // Crop to fill
    display: "block",
  },
  playIcon: {
    position: "absolute",
    backgroundColor: "white",
    borderRadius: "50%",

    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: "#ff0000",
    fontSize: 84,
    transition: "transform 0.2s ease-in-out",
    filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.3))",
  },
  videoContainer: {
    width: "100%",
    position: "relative",
    paddingTop: "56.25%", // 16:9 aspect ratio
  },
  videoWrapper: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
}));

const YouTubeFacade = ({ videoId, title, maxHeight = 495 }) => {
  if (!videoId) return null; // Defensive: don't render if videoId is missing

  const { classes } = useStyles();
  const [isLoaded, setIsLoaded] = useState(false);

  // Get the thumbnail URL for the video
  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;

  const handleClick = () => {
    setIsLoaded(true);
  };

  if (isLoaded) {
    return (
      <div className={classes.videoContainer}>
        <div className={classes.videoWrapper}>
          <YouTubeResponsiveEmbed
            videoId={videoId}
            title={title}
            maxHeight={maxHeight}
            autoPlay={true}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={classes.facadeContainer} onClick={handleClick}>
      <img
        src={thumbnailUrl}
        onError={(e) => {
          e.target.src = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
        }}
        alt={`${title} thumbnail`}
        className={classes.thumbnail}
        loading="lazy"
      />
      <PlayCircleFilledIcon className={classes.playIcon} />
    </div>
  );
};

YouTubeFacade.propTypes = {
  videoId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  maxHeight: PropTypes.number,
};

export default YouTubeFacade;
